<script setup lang="ts">
import AudienceTarget from '../components/AudienceTarget.vue'

const { t } = useI18n()
const { formatNumber } = useNumber()

const showExplanations = computed(() => {
  const total = props.optinTargets
  const stores = props.storesContactsCount
  if (total === null || total === undefined) return false
  if (stores === null || stores === undefined) return false
  if (props.isScopeWithinUserStores) return false
  return total !== stores
})

const props = defineProps({
  isUpdate: {
    type: Boolean,
    required: false,
    default: false
  },
  rules: {
    type: Object,
    required: true
  },
  optinTargets: {
    type: Number,
    default: null
  },
  storesContactsCount: {
    type: Number,
    default: null
  },
  storesCount: {
    type: Number,
    default: null
  },
  isScopeWithinUserStores: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: true
  }
})
</script>

<template>
  <div class="max-h-[calc(100vh-2rem)] overflow-y-auto rounded-md border bg-white">
    <div class="border-b border-border p-4">
      <p class="text-base font-semibold text-foreground">
        {{ t('pages.audienceAside.title') }}
      </p>
    </div>

    <div class="p-3.5">
      <div class="rounded-lg bg-muted px-6 py-4 flex items-center gap-6">
        <img class="w-auto h-8" src="/images/campaign/target.svg" alt="target" />

        <div class="flex flex-col">
          <p class="text-sm font-medium text-foreground">
            {{ t('pages.audienceAside.recipients', (optinTargets || 0) > 1 ? 2 : 1) }}
          </p>

          <div class="flex items-center gap-2">
            <span v-if="loading" class="inline-flex items-center text-sm text-muted-foreground pl-1">
              <svg
                class="mr-2 h-4 w-4 animate-spin text-muted-foreground"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              {{ t('pages.campaign.campaignCreatePage.summary.calculationProgress') }}
            </span>

            <span v-else class="text-lg font-bold text-foreground">{{ formatNumber(optinTargets || 0) }}</span>
          </div>
          <div
            v-if="showExplanations && (storesContactsCount || 0) > 0 && (storesCount || 0) > 0"
            class="flex items-center text-xs text-foreground-secondary mt-2 gap-1"
          >
            <span
              >{{
                t(
                  'pages.audienceAside.recipientsBreakdownStores',
                  {
                    audienceCount: formatNumber(storesContactsCount || 0)
                  },
                  { plural: (storesContactsCount || 0) > 1 ? 2 : 1 }
                )
              }}
            </span>
            <AppTooltip
              class="inline-flex"
              :text="t('pages.audienceAside.recipientsTooltip')"
              tooltip-position="bottom"
              width="w-72"
            >
              <BaseIcon name="IconoirInfoCircle" class="h-4 w-4 cursor-pointer text-foreground-secondary" />
            </AppTooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="p-3.5">
      <AudienceTarget :rules="rules" />
    </div>
  </div>
</template>
